import { ErrorMessage } from "formik";
import React from "react";
import { formatCurrency } from "../../utils";

export default function NumberInput({ field, form, ...props }) {
  return (
    <div
      className={"form-group input-group-lg col-md-" + (props.colNumber || 4)}
    >
      <label className="text-black font-w600">
        {props.required ? "*" : ""}
        {props.title === undefined ? props.label : props.title === "" ? <br/> : props.title}
      </label>
      <input
        // type="number"
        className="form-control"
        placeholder={props.label}
        style={{ height: "calc(1.5em + 1rem + -4px)" }}
        {...field}
        {...props}
        value={field.value ? field.value : ""}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
      <ErrorMessage
        name={field.name}
        render={(msg) => (
          <span className="text-danger">
            <small>*{msg}</small>
          </span>
        )}
      />
    </div>
  );
}
